/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { IconButton, Button, Tooltip, Divider, Avatar, Typography, CircularProgress } from '@material-ui/core'
import { Assignment, Refresh, LayersClear } from '@material-ui/icons'

import Actions from '../../fluid/Actions/ActionFactory'

import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../tableIcons";

import Operation from '../IC/components/Operation/Operation'
import TrainingStage from '../IC/components/Operation/TrainingStage'

import DedupSummary from './DedupSummary'

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({

})

class Dedup extends Component {
    state = {
        loading_data : false,
        loading_data_error : false,
        loading_data_error_message : null,
        models : [],
        selectedRowIndex : null,
        drl_url : null
    }

    tableRef = React.createRef()

    componentDidMount () {
        this.getDedupeICs()
        Actions('http_request', {
            url : "/sainapse/data_rendering_service",
            method : 'get',
            data : {}
        }).then(res => {
            console.log('DRL Result: ', res.data)
            this.setState({...this.state, drl_url : res.data.result[0].url})
        }).catch(err => {

        })
    }

    componentDidUpdate (prevProps, prevState) {
        if (this.state.selectedRowIndex !== null) {
            console.log("Opening Detail Panel :", this.state.selectedRowIndex)
            this.tableRef.current.onToggleDetailPanel([this.state.selectedRowIndex], this.tableRef.current.props.detailPanel)
        }
    }

    getDedupeICs = () => {
        this.setState({...this.state, loading_data : true}, () => {
            Actions('http_request', {
                url : "/sainapse/information_channel",
                method : "get",
                data : {}
            }).then(res => {
                let all_ics = res.data.result
                let dedup_ics = all_ics.filter(ic => ic.operations.includes("Deduplicate"))
                this.setState({...this.state, loading_data : false, models : dedup_ics, loading_data_error : false, loading_data_error_message : null}, () => console.log("Dedup State :", this.state))
            }).catch(err => {
                this.setState({...this.state, loading_data : false, loading_data_error : true, loading_data_error_message : "Error in getting Dedup ICs."})
            })
        })
    }

    renderDedupOperationStatus = (ic_data) => {
        let ic_op = ic_data.operations.filter(op => op === "Deduplicate")
        let operation = ic_op.map(op =>  <TrainingStage size = 'small' ic = {ic_data} op = {op} refresh = {this.getDedupeICs} interaction = {true}/>)
        console.log('IC OP :', operation)
        return operation
    }

    renderReports = (ic_data) => {
        return(
            <div style = {{width : '100%'}}>
                <DedupSummary ic_data = {ic_data} refresh = {this.getDedupeICs} drl_url = {this.state.drl_url}/>
            </div>
        )
    }

    render() { 
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <MaterialTable
                    tableRef={this.tableRef}
                    style={{ width: "100%" }}
                    title="Deduplicator Models"
                    icons={table_icons}
                    data={this.state.models}
                    localization = {{
                        body : {
                            emptyDataSourceMessage : this.state.loading_data_error ? this.state.loading_data_error_message : "No Records to display."
                        }
                    }}
                    columns = {[
                        { 
                            title: "Name", 
                            field: "name",
                        },
                        {
                            title: "IC Created On",
                            field: "created_date",
                            type: "datetime",
                            defaultSort: "desc",
                        },
                        {
                            title: "IC Updated On",
                            field: "updated_date",
                            type: "datetime",
                        },
                        {
                            title : "Deduplication Operation Status",
                            field : "operations",
                            disableClick : true,
                            render : (rowData) => {
                                return (
                                    <div style = {{width : '40vw'}}>
                                        {this.renderDedupOperationStatus(rowData)}
                                    </div>
                                )
                            }
                        }
                    ]}
                    isLoading={this.state.loading_data}
                    loadingType="linear"
                    options={{
                        search: true,
                        paging: false,
                        // headerStyle: {
                        //     height : '50px',
                        //     padding: 0,
                        //     margin: 0,
                        //     backgroundColor: "#F0F0F0",
                        //     zIndex : 10
                        // },
                        headerStyle: {
                            height: "7vh",
                            padding: 0,
                            margin: 0,
                            textAlign: "center",
                            backgroundColor: "#F0F0F0",
                            lineHeight: "1.25",
                        },
                        cellStyle: {
                            height: "5vh",
                            paddingTop: 0,
                            paddingBottom: 0,
                        },
                        maxBodyHeight: "85vh",
                        detailPanelType: "single",
                        draggable: false,
                        toolbarButtonAlignment: "right"
                    }}
                    detailPanel={(rowData) => {
                        return (
                          <div style = {{width : '100%', maxHeight : '70vh', overflow : 'scroll'}}>
                              {this.renderReports(rowData)}
                          </div>
                        );
                    }}
                    onRowClick={(event, rowData, togglePanel) => {
                        let row_index = this.tableRef.current.dataManager.sortedData.findIndex(row => row.name === rowData.name)
                        console.log("Selected Row Index : ", row_index)
                        if (this.state.selectedRowIndex !== row_index) {
                          this.setState({...this.state, selectedRowIndex : row_index}, () => {
                            console.log("Selected Row Index State : ", this.state.selectedRowIndex)
                            // this.tableRef.current.onToggleDetailPanel([row_index], this.tableRef.current.props.detailPanel)
                          })
                        } else {
                          this.tableRef.current.onToggleDetailPanel([row_index], this.tableRef.current.props.detailPanel)
                        }
                      }}
                    components = {{
                        Toolbar : (props) => (
                            <Fragment>
                                <MTableToolbar {...props}/>
                                <Divider/>
                                <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row-reverse",
                                        alignContent: "flex-end",
                                    }}
                                >
                                    <Tooltip title="Refresh" onClick={this.getDedupeICs}>
                                        <IconButton color="primary">
                                            <Refresh />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            </Fragment>
                        )
                    }}
                />
            </ThemeProvider>
        );
    }
}
    
export default withStyles(styles)(Dedup);